import ContactsList from 'components/ContactsList/component';

export default ContactsList;
